import { render, staticRenderFns } from "./PlayerStageWrapper.vue?vue&type=template&id=658fc171&"
import script from "./PlayerStageWrapper.vue?vue&type=script&lang=js&"
export * from "./PlayerStageWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports